import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import * as momentNs from 'moment';
import { ProfileService } from 'src/app/services/profile.service';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { AppConfigurationService } from 'src/app/services/app.configuration.service';
import { File } from '@ionic-native/file/ngx';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { UtilsService } from 'src/app/services/utils.service';
import { ToastService } from '../toast/toast.service';
import { ModalService } from '../modal/modal.service';
import { saveAs } from 'file-saver';
import { Http } from '@capacitor-community/http';
import { Directory, Encoding, Filesystem, FilesystemEncoding } from '@capacitor/filesystem';

const moment = momentNs;

@Component({
  selector: 'app-documentation-list',
  templateUrl: './documentation-list.component.html',
  styleUrls: ['./documentation-list.component.scss'],
})
export class DocumentationListComponent implements OnInit {

  @Input() movementList$: Observable<any>;
  @Input() investProjectDocuments: any;
  @Input() secondaryDocsLits: any;
  loading: boolean;
  fullDocuments: any;
  documents: any;
  hasDocuments: boolean;
  hasSecondaryDocuments: boolean;
  downloadStatus;

  nameDown = true;
  typeDown = true;
  dateDown = true;

  listOfFilter: any;

  year0: string;
  year1: string;
  year2: string;

  projectList: string[] = [];
  documentTypeList: string[] = [];
  yearList: number[] = [];

  constructor(
    public translate: TranslateService,
    public chdRef: ChangeDetectorRef,
    private profileService: ProfileService,
    private overviewService: OverviewProjectService,
    private appConfigurationService: AppConfigurationService,
    private utils: UtilsService,
    private file: File,
    private toastService: ToastService,
    private modalService: ModalService
    ) { }

  ngOnInit() {
    this.hasSecondaryDocuments = !this.utils.checkEmptyField(this.secondaryDocsLits);
    this.year0 = (moment().year()).toString();
    this.year1 = (moment().year() - 1).toString();
    this.year2 = (moment().year() - 2).toString();
    this.downloadStatus = [];
    this.loading = true;
    if (this.movementList$ === undefined) {
      if (this.investProjectDocuments !== undefined) {
        this.operateDocuments(this.investProjectDocuments, true);
      } else {
        this.hasDocuments = false;
        this.loading = false;
      }
    } else {
      this.movementList$.subscribe(resp => {
        this.operateDocuments(resp);
        this.chdRef.detectChanges();
      }, error => {
        this.loading = false;
        this.hasDocuments = false;
        this.chdRef.detectChanges();
      });
    }
  }

  operateDocuments(file, isSpecific?) {
    if (isSpecific) {
      this.fullDocuments = [];
    } else {
      this.fullDocuments = file.documents.filter( item => item.type === 'DOCUMENT' &&
    (item.subtype === 'ANNUAL_REPORT' || item.subtype === 'WEALTH_CERTIFICATE'));
    }
    file.documents.forEach(element => {
      const files = element.files;
      if (element.type === 'SIGNATURE' && element.subtype === 'INVEST') {
        for (let i = 0; i < files.length; i++) {
          const doc = files[i];
          doc.date = element.date;
          doc.subtype = element.subtype;
          doc.type = element.type;
          doc.format = 'application/pdf';
          doc.name = this.translate.instant('DOCUMENTATION.INVEST');
          doc.year = Number(element.date.substring(0, 4));
          doc.project = element.project;
          doc.projectId = element.projectId;
          let itemInArray;
          if (isSpecific !== true) {
            itemInArray = this.fullDocuments.filter(item => item.projectId === doc.projectId).length;
            if (((files[i].status === 'completed' && itemInArray < 1) || files[i].status === 'evidence_generated' || files[i].status === 'stamp_generated') ) { // && itemInArray < 1 ; Buscar mas de un doc no solo este de files[i].status === 'evidence_generated'
              this.fullDocuments.push(doc);
            }
          } else {
            this.fullDocuments.push(doc);
          }
        }
      }
    });

    if (this.fullDocuments.length > 0) {
      this.fullDocuments.forEach((document) => {
        if (document.project && !this.projectList.includes(document.project)) {
          this.projectList.push(document.project);
        }
        if ((document.subtype === 'ANNUAL_REPORT' || document.subtype === 'WEALTH_CERTIFICATE')
            && !this.documentTypeList.includes(this.translate.instant('DOCUMENTATION.DOCUMENT'))) {
          this.documentTypeList.push(this.translate.instant('DOCUMENTATION.DOCUMENT'));
        }
        if (document.subtype === 'INVEST' && document.name && !this.documentTypeList.includes(document.name)) {
          this.documentTypeList.push(document.name);
        }
        if ((document.subtype === 'ANNUAL_REPORT' || document.subtype === 'WEALTH_CERTIFICATE')
            && !this.yearList.includes(document.taxYear)) {
          this.yearList.push(document.taxYear);
        }
        if (document.subtype === 'INVEST' && document.year && !this.yearList.includes(document.year)) {
          this.yearList.push(document.year);
        }
      });
      this.listOfFilter = [
        {
          title: this.translate.instant('DOCUMENTATION.SUBTITLE'),
          list: this.documentTypeList,
          id: 'type'
        },
        {
          title: this.translate.instant('MOVEMENTS.MOVEMENT-LIST.PROJECT'),
          list: this.projectList,
          id: 'project'
        },
        {
          title: this.translate.instant('MOVEMENTS.MOVEMENT-LIST.DATE'),
          list: this.yearList,
          id: 'date'
        }
      ];
    }

    for (let i = 0; i < this.fullDocuments.length; i++) {
      this.downloadStatus.push(0);
      this.fullDocuments[i].index = i;
    }

    if (this.fullDocuments.length > 0) {
      this.hasDocuments = true;
    } else {
      this.hasDocuments = false;
    }
    this.documents = this.fullDocuments;
    this.loading = false;
    this.orderByDate();
    this.chdRef.detectChanges();
  }

  applyFilters(filters: any) {
    let filteredDocuments = this.fullDocuments;
    let checked = [];
    filters.forEach((filter) => {
      switch (filter.id) {
        case 'project':
          checked = [];
          filter.values.forEach((value) => {
            if (value.checked) {
              checked.push(value.name);
            }
          });
          if (checked.length > 0) {
            filteredDocuments = filteredDocuments.filter((document) => checked.includes(document.project));
          }
          break;
        case 'type':
          checked = [];
          filter.values.forEach((value) => {
            if (value.checked) {
              checked.push(value.name);
            }
          });
          if (checked.length > 0) {
            filteredDocuments = filteredDocuments.filter((document) => checked.includes((document.subtype === 'INVEST') ? document.name : this.translate.instant('DOCUMENTATION.DOCUMENT')));
          }
          break;
        case 'date':
          checked = [];
          filter.values.forEach((value) => {
            if (value.checked) {
              checked.push(value.name);
            }
          });
          if (checked.length > 0) {
            filteredDocuments = filteredDocuments.filter((document) => checked.includes((document.subtype === 'INVEST') ? document.year : document.taxYear));
          }
          break;
      }
      this.documents = filteredDocuments;
    });
  }

  orderByName() {
    this.nameDown = !this.nameDown;
    this.typeDown = true;
    this.dateDown = true;
    this.sortByName(this.documents);
  }

  orderByType() {
    this.typeDown = !this.typeDown;
    this.nameDown = true;
    this.dateDown = true;
    this.sortByType(this.documents);
  }

  orderByDate() {
    this.dateDown = !this.dateDown;
    this.nameDown = true;
    this.typeDown = true;
    this.sortByDate(this.documents);
  }

  sortByName(arr) {
    const annual = this.translate.instant('DOCUMENTATION.ANNUAL_RE');
    const certificate = this.translate.instant('DOCUMENTATION.CERTIFICATE');
    const agreement = this.translate.instant('DOCUMENTATION.AGREEMENT');
    if (this.nameDown) {
      arr.sort(function(a, b) {
        let aType;
        let bType;
        switch (a.subtype) {
          case 'ANNUAL_REPORT':
            aType = annual;
            break;
          case 'WEALTH_CERTIFICATE':
            aType = certificate;
            break;
          case 'INVEST':
            aType = agreement;
            break;
        }
        switch (b.subtype) {
          case 'ANNUAL_REPORT':
            bType = annual;
            break;
          case 'WEALTH_CERTIFICATE':
            bType = certificate;
            break;
          case 'INVEST':
            bType = agreement;
            break;
        }
        if (aType > bType) {
          return 1;
        }
        if (aType < bType) {
          return -1;
        }
        return 0;
      });
    } else {
      arr.sort(function(a, b) {
        let aType;
        let bType;
        switch (a.subtype) {
          case 'ANNUAL_REPORT':
            aType = annual;
            break;
          case 'WEALTH_CERTIFICATE':
            aType = certificate;
            break;
          case 'INVEST':
            aType = agreement;
            break;
        }
        switch (b.subtype) {
          case 'ANNUAL_REPORT':
            bType = annual;
            break;
          case 'WEALTH_CERTIFICATE':
            bType = certificate;
            break;
          case 'INVEST':
            bType = agreement;
            break;
        }
        if (aType < bType) {
          return 1;
        }
        if (aType > bType) {
          return -1;
        }
        return 0;
      });
    }
    return arr;
  }

  sortByType(arr) {
    const document = this.translate.instant('DOCUMENTATION.DOCUMENT');
    if (this.typeDown) {
      arr.sort(function(a, b) {
        if (((a.subtype === 'INVEST') ? a.name : document) > ((b.subtype === 'INVEST') ? b.name : document)) {
          return 1;
        }
        if (((a.subtype === 'INVEST') ? a.name : document) < ((b.subtype === 'INVEST') ? b.name : document)) {
          return -1;
        }
        return 0;
      });
    } else {
      arr.sort(function(a, b) {
        if (((a.subtype === 'INVEST') ? a.name : document) < ((b.subtype === 'INVEST') ? b.name : document)) {
          return 1;
        }
        if (((a.subtype === 'INVEST') ? a.name : document) > ((b.subtype === 'INVEST') ? b.name : document)) {
          return -1;
        }
        return 0;
      });
    }
    return arr;
  }

  sortByDate(arr) {
    if (this.dateDown) {
      arr.sort(function(a, b) {
        return ((a.subtype === 'INVEST') ? a.year : a.taxYear) - ((b.subtype === 'INVEST') ? b.year : b.taxYear);
      });
    } else {
      arr.sort(function(a, b) {
        return ((b.subtype === 'INVEST') ? b.year : b.taxYear) - ((a.subtype === 'INVEST') ? a.year : a.taxYear);
      });
    }
    return arr;
  }

  downloadDocument(document) {
    if (this.downloadStatus[document.index] === 0) {
      if (document.subtype === 'INVEST') {
        this.downloadInvestDocuments(document);
      } else {
        this.getDocument(document);
      }
      this.downloadStatus[document.index] = 1;
    }
  }

  dcumentDownloaded(document) {
    this.downloadStatus[document.index] = 2;
    setTimeout(() => { this.downloadStatus[document.index] = 0; }, 5000);
  }

  getDocument(doc) {
    let filename: string;

    if (doc.subtype === 'ANNUAL_REPORT') {
      filename = this.translate.instant('DOCUMENTATION.ANNUAL_RE');
    } else if (doc.subtype === 'WEALTH_CERTIFICATE') {
      filename = this.translate.instant('DOCUMENTATION.CERTIFICATE');
    } else {
      filename =`${this.translate.instant('DOCUMENTATION.AGREEMENT')}: ${doc.project}`;
    }

    this.profileService.getSpecificDocument(doc.type, doc.uuid).subscribe(response => {
      if (Capacitor.getPlatform() === 'ios') {
        const dataBase64 = `${response}`;
        const fileName2 = `${filename}.pdf`;
        const DataBlob = this.utils.b64toBlob(dataBase64, 'application/pdf');

        this.file.writeFile(this.file.tempDirectory, fileName2, DataBlob, { replace: true }).then(res => {
          Share.share({
            title: fileName2,
            url: res.nativeURL,
          }).then(resShare => {
            this.dcumentDownloaded(doc);
            this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_OK'), 'success', true);
          });
        }, err => {
        console.log('Error dataDirectory: ', err);
        });
      } else if (Capacitor.getPlatform() === 'android') {
        const saveAndSharePdf = async (base64Data: string, filename: string) => {
          try {
            const cleanBase64 = base64Data.replace(/^data:application\/pdf;base64,/, '');

            const filePath = `${filename}.pdf`;
            const savedFile = await Filesystem.writeFile({
              path: filePath,
              data: cleanBase64,
              directory: Directory.Documents,
              encoding: FilesystemEncoding.UTF8,
              recursive: true
            });

            await Share.share({
              title: `${filename}.pdf`,
              url: savedFile.uri,
            });

            this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_OK'), 'success', true);

          } catch (error) {
            console.error('Error al guardar o compartir el archivo PDF:', error);
          }
        };

        saveAndSharePdf(response, 'myPdfFile');
      } else {
        const linkSource = 'data:application/pdf;base64,' + response;
        const downloadLink = document.createElement("a");
        const fileName = filename + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.dcumentDownloaded(doc);
      }
    });
  }

  downloadInvestDocuments(doc) {
    const filename = `${this.translate.instant('DOCUMENTATION.AGREEMENT')}: ${doc.project}`;
    this.profileService.getInvestDocuments(doc.projectId).subscribe(async response => {
      const documents = this.parseAsDocumentsArray(response);

      try {
        if (documents && documents.length > 1) {
          // Formato nuevo con varios documentos ({name, format, url, content} cada uno): a un .zip.
          await this.utils.generateDocumentsZip(documents, filename, Capacitor.getPlatform());
        } else {
          // Un único documento: bien del array nuevo, bien el formato antiguo (response = base64 a secas).
          const single = documents && documents.length === 1
            ? documents[0]
            : { name: filename, content: response, format: 'application/pdf' };

          if (single.url) {
            await this.downloadDocumentFromUrl(single);
          } else if (single.content) {
            await this.downloadDocumentFromBase64(single);
          }
        }
      } catch (error) {
        console.error('[downloadInvestDocuments] Error descargando el/los documento(s):', error);
        this.toastService.showToast(this.translate.instant('ERRORS.500'), 'warning');
      }
      // No se marca como "descargado" (y no se quita el loader) hasta que el trabajo async anterior termine.
      this.dcumentDownloaded(doc);
    }, error => {
      console.error('[downloadInvestDocuments] Error obteniendo el/los documento(s):', error);
      this.toastService.showToast(this.translate.instant('ERRORS.500'), 'warning');
      this.downloadStatus[doc.index] = 0;
    });
  }

  private parseAsDocumentsArray(response: any): any[] | null {
    if (Array.isArray(response)) { return response; }
    if (typeof response === 'string') {
      try {
        const parsed = JSON.parse(response);
        return Array.isArray(parsed) ? parsed : null;
      } catch {
        return null;
      }
    }
    return null;
  }

  viewDocument(file) {
    // Formato antiguo (mientras convivan front/back): file.url es un endpoint de metadatos propio
    // que hay que resolver para sacar el enlace real (S3) o el content en base64.
    const isOwnApiUrl = typeof file.url === 'string' && file.url.startsWith(this.appConfigurationService.get('domain'));
    if (isOwnApiUrl) {
      this.overviewService.resolveProjectFile(file.url).subscribe((resolved: any) => {
        if (resolved.url) {
          // El navegador gestiona la descarga/apertura directamente (auth por sesión/cookies).
          window.open(resolved.url);
        } else if (resolved.content) {
          this.downloadDocumentFromBase64(resolved);
        }
      }, error => {
        this.toastService.showToast(this.translate.instant('DOCUMENTATION.DOWNLOAD_FILE_ERROR'), 'warning');
      });
      return;
    }

    // Formato nuevo: file.url ya es el enlace final (S3), o si no, file.content trae el base64.
    if (file.url) {
      this.downloadDocumentFromUrl(file);
    } else if (file.content) {
      this.downloadDocumentFromBase64(file);
    }
  }

  private getDocumentExtension(file): string {
    return file.format ? `.${file.format.split('/').pop()}` : '.pdf';
  }

  private async downloadDocumentFromUrl(file): Promise<void> {
    const ext = this.getDocumentExtension(file);
    const filename = `${file.name}${ext}`;

    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      try {
        const response = await Http.downloadFile({
          url: file.url,
          filePath: filename,
          method: 'GET',
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        });
        await Filesystem.writeFile({
          path: filename,
          data: response.path,
          directory: Directory.Documents,
          encoding: Encoding.UTF8
        });
        const uri = await Filesystem.getUri({ path: filename, directory: Directory.Documents });
        await Share.share({ title: filename, url: uri.uri });
        this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_OK'), 'success', true);
      } catch (error) {
        this.toastService.showToast(this.translate.instant('DOCUMENTATION.DOWNLOAD_FILE_ERROR'), 'warning');
        throw error;
      }
    } else {
      const blob = await fetch(file.url).then(res => res.blob());
      saveAs(blob, filename);
    }
  }

  private async downloadDocumentFromBase64(file): Promise<void> {
    const ext = this.getDocumentExtension(file);
    const filename = `${file.name}${ext}`;
    const format = file.format || 'application/pdf';

    if (Capacitor.getPlatform() === 'ios') {
      const DataBlob = this.utils.b64toBlob(file.content, format);
      const res = await this.file.writeFile(this.file.tempDirectory, filename, DataBlob, { replace: true });
      await Share.share({ title: filename, url: res.nativeURL });
      this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_OK'), 'success', true);
    } else if (Capacitor.getPlatform() === 'android') {
      const cleanBase64 = file.content.replace(/^data:.*;base64,/, '');
      const savedFile = await Filesystem.writeFile({
        path: filename,
        data: cleanBase64,
        directory: Directory.Documents,
        encoding: FilesystemEncoding.UTF8,
        recursive: true
      });
      await Share.share({ title: filename, url: savedFile.uri });
      this.toastService.showToast(this.translate.instant('MESSAGES.DOCUMENT_DOWNLOAD_OK'), 'success', true);
    } else {
      const linkSource = `data:${format};base64,` + file.content;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = filename;
      downloadLink.click();
    }
  }

}
